import { default as i18next } from 'i18next';
import { initReactI18next } from 'react-i18next';

export const supportedLanguages = ['it', 'en'];

const fallbackLanguages = Object.fromEntries(
	supportedLanguages.map(language => [language, [`${language}_custom`, language]])
);

i18next
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		// debug: true,
		lng: 'it',
		supportedLngs: supportedLanguages,
		fallbackLng: fallbackLanguages,
		defaultNS: 'custom',
		fallbackNS: 'core',
		keySeparator: false,
		saveMissing: true,
		interpolation: {
			escapeValue: false // react already safes from xss
		},
		ns: ['core', 'custom']
	});

export default i18next;
